// extracted by mini-css-extract-plugin
export default {"titleWrapper":"style_titleWrapper__Wd3LC","title":"style_title__ocN7X","icon":"style_icon__jhEer"};